import SelectIcon from '@/assets/icons/select-icon.svg';
import SelectDisabledIcon from '@/assets/icons/select-disabled-icon.svg';
import { Palette } from '@/themes/themeOverrides/Palette';

export const MuiIconButtonStyles = {
    styleOverrides: {
        root: {
            backgroundColor: Palette.gray.gray100,
            padding: '8px',
            borderRadius: '12px',
            '&:hover': {
                boxShadow: `inset 0 0 0 2px ${Palette.gray.gray300}`,
            },
            '&.active': {
                boxShadow: `inset 0 0 0 2px ${Palette.black}`,
                outline: `2px solid ${Palette.yellow.yellow200}`,
            },
            '&.RaFilterFormInput-hideButton': {
                backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='icon'%3E%3Cg id='Group 3'%3E%3Cpath id='Vector 29' d='M10 2L2 10' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath id='Vector 30' d='M10 10L2 2' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: '12px',
                width: '24px',
                height: '24px',
                backgroundColor: Palette.gray.gray150,
                zIndex: 3,
                borderRadius: '8px',
                top: '16px',
                '& svg': {
                    display: 'none',
                },
            },
            '&.MuiAutocomplete-popupIndicator': {
                backgroundImage: `url("${SelectIcon}")`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundColor: 'transparent',
                '& svg': {
                    visibility: 'hidden',
                },
                '&.Mui-disabled': {
                    backgroundImage: `url("${SelectDisabledIcon}")`,
                },
            },
            '&.MuiIconButton-colorSecondary': {
                backgroundColor: Palette.white,
                '&:hover': {
                    backgroundColor: Palette.white,
                    boxShadow: `${Palette.boxShadow.elevation2} !important`,
                },
            },
            '&.MuiIconButton-sizeLarge': {
                padding: '12px 16px',
            },
        },
        hideButton: {
            border: '1px solid blue !important',
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='icon'%3E%3Cg id='Group 3'%3E%3Cpath id='Vector 29' d='M10 2L2 10' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath id='Vector 30' d='M10 10L2 2' stroke='%231A1A1A' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E%0A")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: '50%',
        },
    },
};
